import request from '@/utils/ai-train-request'
import { pageParams } from '@/utils/ai-train-data'

// AI训战 - 场景（ai_scene）
// 唯一由任务书 §3.2 明确给出字面路径的是 generate：POST /admin/scene/generate
const apiPath = '/admin/scene'

const aiTrainSceneApi = {
  fetchList(query) {
    const { title, ...params } = pageParams(query)
    return request({ url: apiPath, method: 'get', params: { ...params, keyword: title === undefined ? params.keyword : title } })
  },
  fetchById(id) {
    return request({ url: `${apiPath}/${id}`, method: 'get' })
  },
  fetchDifficultyRules() {
    return request({ url: `${apiPath}/difficulty-rule`, method: 'get' })
  },
  fetchBusinessOptions(params) {
    return request({ url: `${apiPath}/business-options`, method: 'get', params })
  },
  create(data) {
    return request({ url: apiPath, method: 'post', data })
  },
  update(data) {
    return request({ url: apiPath, method: 'put', data })
  },
  deleteById(id) {
    return request({ url: `${apiPath}/${id}`, method: 'delete' })
  },
  setState(id, state) {
    return request({ url: `${apiPath}/${id}/state`, method: 'put', data: { state } })
  },
  /**
   * AIGC 生成草稿：四要素 + 角色类型 + 难度 → system_prompt/opening_line 等草稿字段。
   * 任务书原文：POST /admin/scene/generate {四要素, 角色类型, 难度}（不落库）
   */
  generate(data) {
    return request({ url: `${apiPath}/generate`, method: 'post', data })
  },
  /**
   * 皮科研修院场景打标（ai_scene_tag：课程/身份等级/会议类型/会议场次）
   */
  fetchTags(sceneId) {
    return request({ url: `${apiPath}/${sceneId}/tags`, method: 'get' })
  },
  saveTags(sceneId, tags) {
    return request({ url: `${apiPath}/${sceneId}/tags`, method: 'put', data: { tags } })
  }
}

export default aiTrainSceneApi
